import styles from '../../../../../styles/automationStudio/automationStudio.module.scss';
import { LABELS } from '../../../content';

export default function SavedPlanLoadingState() {
    return (
        <div className={styles.emptyState} data-testid="saved-plan-loading">
            <p className={`${styles.asTypoBody2} ${styles.asTextSecondary}`}>
                {LABELS.LOADING_AUTOMATION_PLAN}
            </p>
        </div>
    );
}
